var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-catalog"},[_vm._m(0),_c('div',{staticClass:"list"},_vm._l((20),function(i){return _c('p',{key:i,staticClass:"s-skeleton__rect--small",style:({'width':`${(Math.random()*6+4)*10}%`})})}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"x-catalog__whole"},[_c('span',{staticClass:"s-skeleton__rect"}),_c('span',{staticClass:"s-skeleton__rect"})])
}]

export { render, staticRenderFns }